import React from 'react';
import { DishBody, DishFooter, DishFooterRow, HorizontalRule } from 'src/shared/design-system/DishFirstCard/styles';
import { WavyEdge } from 'src/shared/design-system/WavyEdge';
import styled from 'styled-components';
import { BorderRadius, Colors, Font } from 'web-common/src/shared/styles';
import { DishCardProps } from './types';

// Not all dish first cards on mobile are landscape, segment rows side scroll with portrait cards

const IMAGE_SIZE = 142;

const Container = styled.div`
  font-family: ${Font.Family.SANS};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;

  width: 100%;
  height: 144px;

  background: ${Colors.WHITE};

  border: 1px solid ${Colors.GRAY_LITE_30};
  border-radius: ${BorderRadius.M};

  overflow: hidden;

  cursor: pointer;
`;

const ImageContainer = styled.div`
  position: relative;
  max-width: ${IMAGE_SIZE}px;
  height: ${IMAGE_SIZE}px;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

// NOTE: This should be renamed to DishCard if/when we remove the legacy explore page
export const DishFirstCardLandscape: React.FC<DishCardProps> = ({
  className,
  imageContent,
  bodyContent,
  footerContent,
  onClick,
  footerRuleEnabled = true,
}) => (
  <Container onClick={onClick} className={className}>
    {imageContent && (
      <ImageContainer>
        {imageContent}
        <WavyEdge position={WavyEdge.Position.RIGHT} />
      </ImageContainer>
    )}
    <Content>
      {bodyContent && <DishBody>{bodyContent}</DishBody>}
      {footerContent && (
        <DishFooter>
          {footerRuleEnabled && <HorizontalRule />}
          <DishFooterRow>{footerContent}</DishFooterRow>
        </DishFooter>
      )}
    </Content>
  </Container>
);
